import React from 'react';
import PropTypes from 'prop-types';
import { components } from 'react-select';
import { useIntl } from 'react-intl';

const ModalPersonSelectItem = (props) => {
  const intl = useIntl();
  const { data } = props;

  return (
    <components.Option {...props}>
      <div className="user-item">
        {data.avatar ? (
          <div className="user-avatar">
            <div style={{ backgroundImage: `url(${data.avatar})` }} className="avatar avatar-40" />
          </div>
        ) : (
          <div className="user-avatar">
            <div className={`avatar avatar-40 icon-avatar ${data.type === 'email' ? 'light-' : ''}gray`}>
              <i className={`fas fa-${data.type === 'email' ? 'at' : 'user'}`} />
            </div>
          </div>
        )}
        <div className="user-item-body">
          <h6 className="user-item-title">
            {data.name || data.label}
            {data.images > 0 && (
              <span className="user-item-title-number">
                ({intl.formatMessage({ defaultMessage: 'in {imagesCount} {imagesCount, plural, one {image} other {images}}' }, { imagesCount: data.images })})
              </span>
            )}
          </h6>
          <span className="user-item-details">
            {data.email}
          </span>
        </div>
      </div>
    </components.Option>
  );
};

ModalPersonSelectItem.propTypes = {
  data: PropTypes.object.isRequired,
};

export default ModalPersonSelectItem;
